import React, { useContext, useEffect, useState } from 'react';
import { Row, notification } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';

import { useFetch } from '../../hooks';
import { LayoutContext } from '../../contexts';
import { URLS } from '../../constants';
import CreateUpdateBrandForm from '../../components/CreateUpdateBrandForm';

function BrandCreate({ history }) {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { setHeaderComponent } = useContext(LayoutContext);
  const { doFetch: createBrandFetch } = useFetch();
  const { doFetch: uploadBrandImageFetch } = useFetch();
  const { doFetch: fetchLanguages } = useFetch();

  // Data states
  const [languageList, setLanguageList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // Load all required data
  useEffect(() => {
    const loadData = async () => {
      try {
        setIsLoading(true);

        // Load languages
        const languagesData = await new Promise((resolve, reject) => {
          fetchLanguages({
            url: URLS.languages,
            onSuccess: resolve,
            onError: reject,
          });
        });

        setLanguageList(languagesData);
        setHeaderComponent('Create New Brand');

      } catch (error) {
        console.error('Error loading brand create data:', error);
        // Handle error - maybe show error message
      } finally {
        setIsLoading(false);
      }
    };

    loadData();

    return () => {
      setHeaderComponent(null);
    };
  }, [fetchLanguages]);

  const uploadBrandImage = async (brandData, formValues) => {
    if (!formValues.image) {
      notification.success({
        placement: 'bottomRight',
        message: 'Brand created successfully.',
        duration: 3,
      });
      // Invalidate brands cache to refetch the list with the new brand
      queryClient.invalidateQueries({ queryKey: ['brands'] });
      navigate('/brands');
      return;
    }

    await uploadBrandImageFetch({
      method: 'FILE_POST',
      url: URLS.uploadBrandImage({ brandId: brandData.id }),
      params: { image: formValues?.image?.file?.originFileObj },
      showSuccessNotification: true,
      successMessage: 'Brand created successfully.',
      onSuccess: () => {
        // Invalidate brands cache to refetch the list with the new brand
        queryClient.invalidateQueries({ queryKey: ['brands'] });
        navigate('/brands');
      },
    });
  };

  const createNewBrand = async formValues => {
    const translationsObject = languageList.reduce((acc, language) => {
      acc[language.id] = formValues[`name.${language.id}`];
      return acc;
    }, {});

    console.log('translationsObject: ', translationsObject);
    console.log('formValues: ', formValues);

    await createBrandFetch({
      url: URLS.createBrand(),
      params: { ...translationsObject, tag_ids: formValues.tagIds },
      onSuccess: data => uploadBrandImage(data, formValues),
    });
  };

  if (isLoading) {
    return (
      <Row>
        <div style={{ textAlign: 'center', padding: '50px' }}>
          Loading brand creation data...
        </div>
      </Row>
    );
  }

  return (
    <Row>
      <CreateUpdateBrandForm languageList={languageList} onSubmit={createNewBrand} />
    </Row>
  );
}

export default BrandCreate;
